import { makeAutoObservable } from "mobx";
import { decodeJwtUser } from "./jwt-decode";
export class OAuthStore {
    static instance;
    tokenType = null;
    scope = null;
    expiresIn = null;
    extExpiresIn = null;
    accessToken = null;
    refreshToken = null;
    jwtUser = null;
    expirationTime = null;
    constructor() {
        makeAutoObservable(this, {
            setToken: true,
            clearToken: true,
        });
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new OAuthStore();
        }
        return this.instance;
    }
    isAuthenticated() {
        const t = OAuthStore.getInstance();
        return t.accessToken !== null
            && t.expirationTime !== null
            && t.expirationTime > Date.now();
    }
    tokenExpired() {
        const t = OAuthStore.getInstance();
        return t.accessToken !== null
            && t.expirationTime !== null
            && t.expirationTime <= Date.now();
    }
    setToken(tokenType = null, scope = null, expiresIn = null, extExpiresIn = null, accessToken = null, refreshToken = null) {
        this.tokenType = tokenType;
        this.scope = scope;
        this.expiresIn = expiresIn;
        this.extExpiresIn = extExpiresIn;
        this.accessToken = accessToken;
        this.refreshToken = refreshToken;
        // also decode unique user name and email when setting token
        if (accessToken) {
            this.jwtUser = decodeJwtUser(accessToken);
            if (expiresIn) {
                this.expirationTime = Date.now() + (expiresIn * 1_000);
            }
        }
        else {
            // user is logged out
            this.jwtUser = null;
            this.expirationTime = null;
        }
    }
    clearToken() {
        this.setToken(); // call with implicit null parameters
    }
}
